import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setDispatchFactorsOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { moveOptionToEnd } from '../../../utilities/options.util'

export function* getDispatchFactorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getDispatchFactorsOptions])
    const { entity } = response
    moveOptionToEnd(entity, 110)
    yield put(setDispatchFactorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getDispatchFactorsOptions() error: ${e}`))
  }
}

export function* getDispatchFactorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDispatchFactorsOptions)
}
